// Binghamton's undergraduate majors (#2748). Read on 2026-10-01 from the
// official 2026-2027 Binghamton University Academic Guide
// (catalog.binghamton.edu, catoid=7). The catalog's pages answer plain
// fetches with a browser challenge, so the program list was read through the
// catalog's own public widget API (catalog id 3 = "2026-2027 Binghamton
// University Academic Guide"): every program typed "Undergraduate Programs"
// with a bachelor's degree type, placed under the school its catalog
// hierarchy names. Minors, graduate and combined bachelor's-master's programs
// and the three non-degree university-wide entries (English for
// Multilinguals, Experiential Learning, Scholars Program) are left out.
// Names and degree abbreviations are the catalog's own (BA, BS, BFA, MusB,
// BSW; "BS/BS" for the five-year physics and computer science program); the
// catalog suffix ", BS" etc. is moved into the degree field. Physics tracks
// are listed as the catalog lists them. The notes on the dual-diploma and
// nursing entries quote the catalog's program descriptions. The KB's majors
// list was the starting point; the catalog wins.
const majors = {
    "slug": "state-university-of-new-york-at-binghamton",
    "read": "2026-10-01",
    "intro": "Every bachelor's degree program in Binghamton's official 2026-2027 Academic Guide, grouped by the school that offers it, with the degree it leads to. Minors, certificates and graduate programs are left out.",
    "groups": [
        {
            "name": "Harpur College of Arts and Sciences",
            "source": {
                "label": "Binghamton 2026-2027 Academic Guide, Harpur College of Arts and Sciences",
                "url": "https://catalog.binghamton.edu/content.php?catoid=7&navoid=300"
            },
            "majors": [
                {
                    "name": "Africana Studies",
                    "degree": "BA"
                },
                {
                    "name": "Ancient Mediterranean Studies",
                    "degree": "BA"
                },
                {
                    "name": "Anthropology",
                    "degree": "BA"
                },
                {
                    "name": "Anthropology",
                    "degree": "BS"
                },
                {
                    "name": "Art History",
                    "degree": "BA"
                },
                {
                    "name": "Asian and Asian American Studies",
                    "degree": "BA"
                },
                {
                    "name": "Biochemistry",
                    "degree": "BS"
                },
                {
                    "name": "Biological Sciences",
                    "degree": "BA"
                },
                {
                    "name": "Biological Sciences",
                    "degree": "BS"
                },
                {
                    "name": "Chemistry",
                    "degree": "BA"
                },
                {
                    "name": "Chemistry",
                    "degree": "BS"
                },
                {
                    "name": "Chinese Studies",
                    "degree": "BA"
                },
                {
                    "name": "Cinema",
                    "degree": "BA"
                },
                {
                    "name": "Comparative Literature",
                    "degree": "BA"
                },
                {
                    "name": "Economics",
                    "degree": "BA"
                },
                {
                    "name": "Economics",
                    "degree": "BS"
                },
                {
                    "name": "English",
                    "degree": "BA"
                },
                {
                    "name": "Environmental Science",
                    "degree": "BS"
                },
                {
                    "name": "Environmental Studies",
                    "degree": "BA"
                },
                {
                    "name": "French",
                    "degree": "BA"
                },
                {
                    "name": "Geography",
                    "degree": "BA"
                },
                {
                    "name": "Geological Sciences",
                    "degree": "BA"
                },
                {
                    "name": "Geological Sciences",
                    "degree": "BS"
                },
                {
                    "name": "German Studies",
                    "degree": "BA"
                },
                {
                    "name": "Global Public Health",
                    "degree": "BA"
                },
                {
                    "name": "Global Public Health",
                    "degree": "BS"
                },
                {
                    "name": "Global and International Affairs",
                    "degree": "BS",
                    "note": "A dual-diploma program with Middle East Technical University (METU); students spend the second and fourth years at Binghamton."
                },
                {
                    "name": "Greek and Latin",
                    "degree": "BA"
                },
                {
                    "name": "Hebrew Studies",
                    "degree": "BA"
                },
                {
                    "name": "History",
                    "degree": "BA"
                },
                {
                    "name": "Integrative Neuroscience",
                    "degree": "BS"
                },
                {
                    "name": "Italian",
                    "degree": "BA"
                },
                {
                    "name": "Japanese Studies",
                    "degree": "BA"
                },
                {
                    "name": "Judaic Studies",
                    "degree": "BA"
                },
                {
                    "name": "Korean Studies",
                    "degree": "BA"
                },
                {
                    "name": "Latin",
                    "degree": "BA"
                },
                {
                    "name": "Latin American and Caribbean Studies",
                    "degree": "BA"
                },
                {
                    "name": "Linguistics",
                    "degree": "BA"
                },
                {
                    "name": "Mathematical Sciences",
                    "degree": "BA"
                },
                {
                    "name": "Mathematical Sciences",
                    "degree": "BS"
                },
                {
                    "name": "Medieval and Early Modern Studies",
                    "degree": "BA"
                },
                {
                    "name": "Middle East Studies",
                    "degree": "BA"
                },
                {
                    "name": "Music",
                    "degree": "BA"
                },
                {
                    "name": "Music",
                    "degree": "MusB"
                },
                {
                    "name": "Musical Theatre",
                    "degree": "BFA"
                },
                {
                    "name": "Philosophy",
                    "degree": "BA"
                },
                {
                    "name": "Philosophy, Politics, and Law",
                    "degree": "BA"
                },
                {
                    "name": "Physics",
                    "degree": "BA"
                },
                {
                    "name": "Physics",
                    "degree": "BS"
                },
                {
                    "name": "Physics - Applied Physics Track",
                    "degree": "BS"
                },
                {
                    "name": "Physics - Mathematical Physics Track",
                    "degree": "BS"
                },
                {
                    "name": "Physics and Computer Science Five-Year Program",
                    "degree": "BS/BS",
                    "note": "A five-year program leading to the BS in physics and the BS in computer science."
                },
                {
                    "name": "Political Science",
                    "degree": "BA"
                },
                {
                    "name": "Psychology",
                    "degree": "BA"
                },
                {
                    "name": "Russian Studies",
                    "degree": "BA"
                },
                {
                    "name": "Sociology",
                    "degree": "BA"
                },
                {
                    "name": "Spanish",
                    "degree": "BA"
                },
                {
                    "name": "Studio Art",
                    "degree": "BA"
                },
                {
                    "name": "Studio Art",
                    "degree": "BFA"
                },
                {
                    "name": "Theatre",
                    "degree": "BA"
                },
                {
                    "name": "Women, Gender and Sexuality Studies",
                    "degree": "BA"
                }
            ]
        },
        {
            "name": "Thomas J. Watson College of Engineering and Applied Science",
            "source": {
                "label": "Binghamton 2026-2027 Academic Guide, Thomas J. Watson College of Engineering and Applied Science",
                "url": "https://catalog.binghamton.edu/content.php?catoid=7&navoid=303"
            },
            "majors": [
                {
                    "name": "Biomedical Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Computer Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Computer Science",
                    "degree": "BS"
                },
                {
                    "name": "Electrical Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Industrial and Systems Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Information Systems, Dual-Diploma",
                    "degree": "BS",
                    "note": "A dual-diploma program with Istanbul Technical University (ITU); students spend the second and fourth years at Binghamton."
                },
                {
                    "name": "Mechanical Engineering",
                    "degree": "BS"
                }
            ]
        },
        {
            "name": "School of Management",
            "source": {
                "label": "Binghamton 2026-2027 Academic Guide, School of Management",
                "url": "https://catalog.binghamton.edu/content.php?catoid=7&navoid=301"
            },
            "majors": [
                {
                    "name": "Accounting",
                    "degree": "BS"
                },
                {
                    "name": "Business Administration",
                    "degree": "BS"
                }
            ]
        },
        {
            "name": "Decker College of Nursing and Health Sciences",
            "source": {
                "label": "Binghamton 2026-2027 Academic Guide, Decker College of Nursing and Health Sciences",
                "url": "https://catalog.binghamton.edu/content.php?catoid=7&navoid=299"
            },
            "majors": [
                {
                    "name": "Nursing BAT",
                    "degree": "BS",
                    "note": "For students who already hold a bachelor's degree: a 12-month accelerated second bachelor's degree."
                },
                {
                    "name": "Nursing Traditional",
                    "degree": "BS"
                },
                {
                    "name": "Nursing, RN-BS Program",
                    "degree": "BS",
                    "note": "For registered nurses completing a bachelor of science."
                }
            ]
        },
        {
            "name": "College of Community and Public Affairs",
            "source": {
                "label": "Binghamton 2026-2027 Academic Guide, College of Community and Public Affairs",
                "url": "https://catalog.binghamton.edu/content.php?catoid=7&navoid=298"
            },
            "majors": [
                {
                    "name": "Human Development",
                    "degree": "BS"
                },
                {
                    "name": "Social Work",
                    "degree": "BSW"
                }
            ]
        }
    ]
};

export default majors;
